import Calendar from 'svg/Calendar';
import Clock from 'svg/Clock';
import classNames from 'styles/utils/classNames';

interface Props {
  /** `Sunday, September 19` */
  dateLabel: string;
  /** `8 – 9 PM` */
  timeLabel: string;
  className?: string;
}

/** The dark recap of what the player has picked, shown above the court list. */
export default function BookingDetailsCard({ dateLabel, timeLabel, className }: Props) {
  return (
    <div
      className={classNames(
        'flex flex-col gap-ds-md rounded-xl bg-color-bg-lightmode-invert p-ds-md dark:bg-color-bg-darkmode-invert',
        className,
      )}
    >
      <p className="typography-product-subheading text-color-text-lightmode-invert dark:text-color-text-darkmode-invert">
        Court booking details
      </p>
      <span className="h-px w-full bg-color-border-card-darkmode dark:bg-color-border-card-lightmode" />
      <div className="flex flex-col gap-ds-sm">
        <span className="flex items-center gap-ds-xs">
          <Calendar className="h-5 w-5 shrink-0 text-color-text-lightmode-invert dark:text-color-text-darkmode-invert" />
          <span className="typography-product-subheading-mobile text-color-text-lightmode-invert dark:text-color-text-darkmode-invert">
            {dateLabel}
          </span>
        </span>
        <span className="flex items-center gap-ds-xs">
          <Clock className="h-5 w-5 shrink-0 text-color-text-lightmode-invert dark:text-color-text-darkmode-invert" />
          <span className="typography-product-subheading-mobile text-color-text-lightmode-invert dark:text-color-text-darkmode-invert">
            {timeLabel}
          </span>
        </span>
      </div>
    </div>
  );
}
